<template>
  <div class="news-page">
    <banner>
      新闻与文化
    </banner>

    <div class="news-list">
      <div class="tab-tag-container">
        <div class="tab-tag">
          <div class="tab-tag-div">
            <router-link class="active"
                         :to="{name: 'News'}">一维新闻</router-link>
            <!--<a href="#">一维文化</a>-->
          </div>
        </div>
      </div>
      <div class="show-list-container">
        <div class="show-list">
          <div class="btn-group">
            <button v-for="(item, index) in conds"
                    :key="index"
                    @click="selectYear(item.year)"
                    :class="{'active': selected === item.year}">
              {{item.year}}年
            </button>
          </div>
          <div class="info-list">
            <router-link :to="{path: '/news/:'+item.id}"
                         v-for="(item, idx) in formatedShowList"
                         :key="idx"
                         :target="'_blank'">
              <dl>
                <dd>
                  <i class="title-circle"></i>
                  <h3 class="title-h3 tit-h3">
                    {{item.title}}
                  </h3>
                  <time>{{item.gmtPublish}}</time>
                  <p class="title-txt">
                    {{item.summary}}
                  </p>
                </dd>
                <dt>
                  <img :src="item.coverUrl" alt="" />
                </dt>
              </dl>
            </router-link>
            <button class="more-news"
                    v-show="hasMore"
                    @click="loadMore">
              查看更多
            </button>
            <div class="disabled-txt"
                 v-show="!hasMore">没有更多了~</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Banner from '../components/Banner.vue';
  import fetch from '../server/index';

  export default {
    data () {
      return {
        conds: [],
        selected: 0,
        hasMore: true,
        showList: [],
        page: 1,
        pageSize: 10
      }
    },
    computed: {
      formatedShowList () {
        // eslint-disable-next-line
        let webReg = 'http';
        let format = this.showList.map(n => {
          if (n.coverUrl.indexOf(webReg) >= 0) {
            return n;
          }
          n.coverUrl = window.config.host + n.coverUrl
          return n;
        });

        return format;
      }
    },
    watch: {
      selected () {
        this.hasMore = true;
        this.getList();
      }
    },
    methods: {
//      获取年份可选数据
      getConditions () {
        fetch('/api/policyInfo/year').then(res => {
          this.conds = res
          this.selected = res[res.length - 1].year
        }, err => {
          console.log(err)
        }).catch(e => {})
      },
//      获取资讯列表
      getList (append) {
        fetch('/api/policyInfo/list', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          year: this.selected
        }).then(res => {
          if (append) {
            this.showList = this.showList.concat(res.rows)
          } else {
            this.showList = res.rows
          }
          if (res.total >= this.showList.length) {
            this.hasMore = false;
          } else {
            this.hasMore = true;
          }
        }, err => {
          console.log(err)
        }).catch(e => {})
      },
//      加载更多方法
      loadMore () {
        this.page++
        this.getList(true)
      },
      selectYear (y) {
        this.selected = y;
      }
    },
    components: {
      Banner
    },
    created () {
      this.getConditions();
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .news-page {
    $theme-color: #00ccff;
    width: 100%;
    height: 100%;
    background: #f4f4f4;
    .pulic-banner-container {
      background-image: url('../assets/images/banners/bg-news.png');
      .banner-content .banner-txt{
        font-size: 30px;
      }
    }
    .news-list {
      width: 100%;
      .tab-tag-container {
        margin-top: 85px;
        .tab-tag {
          @include public_content();
          height: 100%;
          .tab-tag-div {
            width: 500px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 0 30px;
            a {
              color: #959595;
              display: block;
              font-size: 20px;
              height: 52px;
              padding-left: 16px;
              padding-right: 16px;
              line-height: 52px;
              border-top: 2px solid transparent;
              border-bottom: 2px solid transparent;
              &:hover,
              &.active{
                color: $theme-color;
                border-top: 2px solid $theme-color;
                border-bottom: 2px solid $theme-color;
              }
            }
          }
        }
      }
      .show-list-container {
        background: #f6f6f6;
        margin-bottom: 26px;
        .show-list {
          @include public_content();
          padding: 0 60px;
          .btn-group {
            margin-top: 62px;
            height: 38px;
            margin-bottom: 30px;
            button {
              color: $theme-color;
              border: none;
              border-radius: 3px;
              padding: 0 35px;
              height: 38px;
              line-height: 38px;
              font-size: 20px;
              background: none;
              margin-right: 14px;
              cursor: pointer;
              &:hover,
              &.active{
                color: #fff;
                background: $theme-color;
              }
            }
          }
          .info-list {
            width: 100%;
            position: relative;
            padding-bottom: 20px;
            &:before {
              content: '';
              width: 2px;
              height: 100%;
              background: #e5e5e5;
              position: absolute;
              left: -30px;
            }
            dl {
              width: 980px;
              padding:60px 30px;
              background: #fff;
              color: #4d4d4d;
              position: relative;
              border: 1px solid transparent;
              margin-bottom: 20px;
              border-radius: 4px;
              &:before {
                content: '';
                border-width: 20px 20px 20px 0;
                border-style: solid;
                border-color: transparent #fff transparent transparent;
                position: absolute;
                top: 50px;
                left: -20px;
              }
              &:after {
                content: '';
                border-width: 20px 20px 20px 0;
                border-style: solid;
                border-color: transparent #fff transparent transparent;
                position: absolute;
                top: 50px;
                left: -19px;
              }
              &:hover {
                .title-h3 {
                  color: $theme-color;
                }
                &:before {
                  border-color: transparent $theme-color transparent transparent;
                }
                border: 1px solid $theme-color;
                .title-circle {
                  width: 13px;
                  height: 13px;
                  border: 2px solid $theme-color;
                  left: -37px;
                }
              }
              dt{
                  width: 290px;
                  height: 150px;
                  position: absolute;
                  right: 30px;
                  top: 40px;
                  overflow: hidden;
                  img{
                      width: 100%;
                      /*height: 100%;*/
                      display: block;
                  }
              }
              dd{
                 width: 600px;
              }
              .tit-h3{
                margin-top: -28px;
                white-space: nowrap;
                overflow : hidden;
                text-overflow: ellipsis;
              }
              .title-txt{
                padding-right: 20px;
                font-size: 14px;
                line-height: 25px;
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                 /* autoprefixer: off */
                -webkit-box-orient: vertical;
                /* autoprefixer: on */
              }
              .title-circle {
                width: 9px;
                height: 9px;
                border-radius: 100%;
                border: 2px solid #454545;
                background: #fff;
                position: absolute;
                left: -35px;
                top: 64px;
              }
              time {
                line-height: 35px;
                padding-left: 18px;
                display: block;
                margin-bottom: 20px;
                background: url('../assets/images/i-time.png') no-repeat left center;
              }
            }
            .more-news {
              width: 245px;
              height: 40px;
              display: block;
              cursor: pointer;
              border: 1px solid $theme-color;
              color: $theme-color;
              font-size: 18px;
              margin: 20px auto 0;
              padding-left: 16px;
              background: #fff url('../assets/images/i-more.png') no-repeat 65px center;
            }
            .disabled-txt{
              text-align: center;
              color: #5c5c5c;
              line-height: 2em;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pc/News.vue